document.addEventListener("DOMContentLoaded", function () {
  // HOME PAGE
  const arrowClick = document.querySelector(".arrow_click");

  if (arrowClick) {
    arrowClick.addEventListener("click", function (event) {
      event.preventDefault();
      const targetSection = document.querySelector(".secnd_sec_scroll");

      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  }

  // FAQ PAGE
  const faqQuestions = document.querySelectorAll(".faq_ques");

  if (faqQuestions.length > 0) {
    faqQuestions.forEach((item) => {
      item.addEventListener("click", function () {
        let answer = this.nextElementSibling;

        if (answer && answer.classList.contains("faq_ans")) {
          let isActive = answer.classList.contains("active");

          document
            .querySelectorAll(".faq_ans")
            .forEach((ans) => ans.classList.remove("active"));

          if (!isActive) {
            answer.classList.add("active");
          }
        }
      });
    });
  }

  //SIZE CHART:

  const sizeChartTrigger = document.querySelector(".cstm_size_chart");
  const sizeChartWrapper = document.querySelector(".size_chart_wrapper");
  const sizeChartPopup = document.querySelector(".size_chart");
  const closeButton = document.querySelector(".close_btn");
  const sizepopoOverlay = document.querySelector(".size_chart--overlay");

  if (sizeChartTrigger && sizeChartWrapper && closeButton) {
    sizeChartTrigger.addEventListener("click", function () {
      sizeChartWrapper.style.display = "flex"; // Show the size chart
      document.body.classList.add("body-over");
    });

    closeButton.addEventListener("click", function () {
      sizeChartWrapper.style.display = "none"; // Hide the size chart
      document.body.classList.remove("body-over");
    });

    sizepopoOverlay.addEventListener("click", function () {
      sizeChartWrapper.style.display = "none"; // Hide the size chart
      document.body.classList.remove("body-over");
    });

    // Close when clicking outside the size chart
    sizeChartWrapper.addEventListener("click", function (event) {
      if (!sizeChartPopup.contains(event.target)) {
        sizeChartWrapper.style.display = "none";
      }
    });
  }

  //LOAD MORE TERMS OF SERVICE

  var content = document.getElementById("teams");
  var button = document.getElementById("team_show-mores");

  if (content && button) {
    button.onclick = function () {
      if (content.classList.contains("open")) {
        content.classList.remove("open");
        button.innerHTML = "LOAD MORE";
      } else {
        content.classList.add("open");
        button.innerHTML = "LESS";
        button.style.display = "none"; // Hide the button
      }
    };
  }

  //Custom Slider

  var splideElement = document.querySelector(".splide"); 

  if (splideElement) {
    // Only initialize if the element exists
    var splide = new Splide(splideElement, {
      type: "loop",
      perPage: 3,
      gap: "5.2rem",
      perMove: 1,
      breakpoints: {
        1280: { perPage: 3, gap: "3rem" },
        1200: { perPage: 3 },
        768: { perPage: 2 },
        480: { perPage: 1 },
      },
    });

    splide.mount();
  }
});
